import { Camera, Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-secondary text-secondary-foreground grain-overlay" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16">
        <div className="grid md:grid-cols-3 gap-10">
          <div>
            <div className="flex items-center gap-2">
              <span className="w-8 h-8 rounded-sm bg-primary text-primary-foreground grid place-items-center">
                <Camera size={16} strokeWidth={2.4} />
              </span>
              <span className="font-display font-bold text-lg">
                Snap<span className="text-primary">.</span>Send<span className="text-primary">.</span>Repair
              </span>
            </div>
            <p className="mt-4 text-sm opacity-70 leading-relaxed max-w-xs">
              Insured minor home repairs and end-of-lease make-goods, sorted from your phone. Australia-wide.
            </p>
          </div>
          <div>
            <div className="text-xs uppercase tracking-widest opacity-60 mb-4">Explore</div>
            <ul className="space-y-2 text-sm">
              <li><a href="#how" className="hover:text-primary transition-colors">How it works</a></li>
              <li><a href="#services" className="hover:text-primary transition-colors">Services</a></li>
              <li><a href="#faq" className="hover:text-primary transition-colors">FAQ</a></li>
              <li><a href="#quote" className="hover:text-primary transition-colors">Get a quote</a></li>
            </ul>
          </div>
          <div>
            <div className="text-xs uppercase tracking-widest opacity-60 mb-4">Contact</div>
            <a href="mailto:quotes@snapsendrepair.com.au" className="inline-flex items-center gap-2 text-sm hover:text-primary transition-colors">
              <Mail size={14} /> quotes@snapsendrepair.com.au
            </a>
            <p className="mt-3 text-xs opacity-60 leading-relaxed">
              We only take requests through the quote form — that way every job comes with the photos we need to price it properly.
            </p>
          </div>
        </div>
        <div className="mt-12 pt-6 border-t border-white/10 text-xs opacity-60 flex flex-col sm:flex-row justify-between gap-2">
          <div>© {new Date().getFullYear()} Snap Send Repair. All rights reserved.</div>
          <div>Simple · Easy · Fast · Trustworthy · Insured</div>
        </div>
      </div>
    </footer>
  );
}
